import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class AlternativeCollegesService {

  constructor(private _http: HttpClient) {
  }

  getAlternativeCollegesByEnrollId(enrollId) {
    return this._http.get<any[]>(`api/enrolls/enrollApplication/getAlternativeColleges/${enrollId}`);
  }

  saveAlternativeColleges(params, enrollId) {
    return this._http.post<any[]>(`api/enrolls/enrollApplication/saveAlternativeColleges/${enrollId}`, params);
  }

  transferEnrollToAlternativeCollege(params, enrollId) {
    return this._http.post<any[]>(`api/enrolls/enrollApplication/transferEnrollToAlternativeCollege/${enrollId}`, params);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/services/alternative-colleges.service.ts